module.exports = __webpack_public_path__ + "static/media/8.504da2ca.png";